export const FETCH_BRANCHES_SELECTORS = 'branches/FETCH_BRANCHES_SELECTORS';
export const FETCH_BRANCHES_ATOMS = 'branches/FETCH_BRANCHES_ATOMS';
